<style scoped>
	.common-manage-dialog .el-dialog__body {
		padding: 10px !important;
	}
</style>

<template>
	<el-dialog title="常用功能" class="common-manage-dialog" top="30px" :visible.sync="visible" width="700px"
		:close-on-click-modal="true">
		<el-card shadow="never">
			<el-input placeholder="请输入菜单名称" @input="handleChange" clearable v-model="queryText">
				<i slot="suffix" class="el-input__icon el-icon-search"></i>
			</el-input>
			<el-table :data="menuAllList" :show-header="false" max-height="460px" style="margin-top: 10px;">
				<el-table-column prop="menu" />
				<el-table-column width="80px">
					<template slot-scope="scope">
						<i class="el-icon-star-on"
							:style="{fontSize: '26px',color: isSelected(scope.row)?'#f18516':'#aba8a8',cursor: 'pointer'}"
							@click="handleChangeMenu(scope.row)"></i>
					</template>
				</el-table-column>
			</el-table>
		</el-card>
	</el-dialog>
</template>


<script>
	import {
		menuList, hideMenuList
	} from '@/utils/commonlyMenu';
  import {CompanyApi} from "@/api/server/company";
	export default {
		components: {},
		data() {
			return {
				visible: false,
				queryText: '',
				menuAllList: [],
				selectedList: []
			};
		},
		created() {

		},
		mounted() {

		},
		methods: {
			async show(menuIds){
        const response = await CompanyApi.queryCurrentCompany();
        let {code, data} = response;
        const systemVersionType = data?.systemVersionType || 1;
				this.menuAllList = systemVersionType == 1? menuList.filter(item => !hideMenuList.includes(item.id)):menuList;
				this.selectedList = menuIds;
				this.visible = true;
			},
			isSelected(item) {
				return this.selectedList.includes(item.id);
			},
			handleChangeMenu(item) {
				if (this.selectedList.includes(item.id)) {
					//删除常用功能
					this.selectedList = this.selectedList.filter(id => id !== item.id);
					this.$emit("handleRemoveMenu", item.id);
				} else {
					//添加常用功能
					this.selectedList.push(item.id);
					this.$emit("handleAddMenu", item);
				}
			},
			handleChange() {
				this.menuAllList = menuList.filter(item => item.title.includes(this.queryText));
			}
		}
	};
</script>